import { SESSION_LOCAL_STORAGE_KEY as LOCAL_STORAGE_KEY } from 'assets/configurations/envConfigs';
import { UserSession, useUserSession } from 'common/stores/UserSessionStore';
import React, { useState } from 'react';



let initState = '';

function encodeData(data = '') {
    if(__NODE_ENV__ === 'production') {
        return btoa(encodeURIComponent(data));
    };

    return data;
}

function decodeData(data) {
    let storedString = '';

    if(__NODE_ENV__ === 'production') {

        storedString = atob(data);

        if (storedString.indexOf('{') < 0) {
            storedString = decodeURIComponent(storedString);
        };

        return JSON.parse(storedString);
    };

    return JSON.parse(data);
};

function loadSession() {
    if(!globalThis.localStorage) {
        return {};
    };

    let storedString = localStorage.getItem(LOCAL_STORAGE_KEY) || initState;
    let userSession = {};

    try {
        userSession = decodeData(storedString);
    } catch (error) {
        console.error(error);
        resetSession();
    };

    return userSession;
};

function persistSession(session) {
    let dataToStore = JSON.stringify(session || {});
    
    try {
        dataToStore = encodeData(dataToStore);
        localStorage.setItem(LOCAL_STORAGE_KEY, dataToStore);
    } catch (error) {
        console.error(error);
        resetSession();
    };
}

function resetSession() {
    return localStorage.setItem(LOCAL_STORAGE_KEY, initState);
};


if(__NODE_ENV__ === 'production') {
    initState = 'e30=';
};

if(__NODE_ENV__ !== 'production') {
    initState = '{}';
};


export function UserSessionComponent({ children }) {
    const [userSession, setUserSession] = useState(loadSession());
    const storedSession = useUserSession();

    function updateSession(session) {
        persistSession(session);
        setUserSession(session);
    };

    return (
        <UserSession.Provider value={{ ...storedSession, session: userSession, updateSession }}>
            {children}
        </UserSession.Provider>
    );
};